import { createI18n } from '@app/i18n';
import participant from '../assets/translations/en/participant.json';

export const i18n = createI18n('participant', { participant });
